<template>
  <el-dialog title="联系客户" v-model="visible" width="1240px">
    <page-request ref="table" url="/api/mgr/business/shop/customer/list" :table-header="tableHeader" :expend="expend" :op-width="200">
      <template #op="scope">
        <b-button @click="openChat(scope.row)">发起会话</b-button>
      </template>
    </page-request>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="visible=false">关闭</el-button>
          </span>
    </template>
  </el-dialog>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import PageRequest from "@/components/base/page-request.vue";
import BButton from "@/components/el/b-button.vue";

export default {
  name: "customer-dialog",
  components: {BButton, PageRequest, QcContainer},
  data() {
    return {
      visible:false,
      tableHeader: [
        {type:"user", label: "客户",width:300},
        {prop:"phone", label: "电话",width:200},
        {prop: "remark", label: "备注"}
      ],
      expend: [
        {label: "名称", prop: "nickname"},
        {label: "电话", prop: "phone"},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    show(){
      this.visible =true;
    },
    openChat(row){
      this.$emit('open',row);
      this.visible = false;
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
